import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'

export const TandCmodal: React.FC<{
  className?: string
  style?: React.CSSProperties
}> = ({
  className = 'position-relative tc-lgray fz-12 cursor',
  style = { top: '40px', left: '65px' },
}) => {
  const [show, setShow] = useState(false)

  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        className="modal-w-50 modal-rounded-0"
      >
        <Modal.Header closeButton style={{ border: 'none' }} className="pb-0">
          <Modal.Title>Terms & Conditions</Modal.Title>
        </Modal.Header>
        <Modal.Body className="px-3 px-lg-5 pb-5">
          <p>
            Earn up to $3500 cash gift based on your destination wedding guest
            room bookings on Kiss & Tell.
          </p>

          <p className="mb-0 ml-3">
            <b>$450:</b> 10+ rooms (20+ guests)
          </p>
          <p className="mb-0 ml-3">
            <b>$900:</b> 20+ rooms (40+ guests)
          </p>
          <p className="mb-0 ml-3">
            <b>$1,350:</b> 30+ rooms (60+ guests)
          </p>
          <p className="mb-0 ml-3">
            <b>$1,800:</b> 45+ rooms (90+ guests)
          </p>
          <p className="mb-0 ml-3">
            <b>$2,250:</b> 60+ rooms (120+ guests)
          </p>
          <p className="mb-0 ml-3">
            <b>$2,700:</b> 75+ rooms (150+ guests)
          </p>
          <p className="mb-0 ml-3">
            <b>$3,500:</b> 100+ rooms (200+ guests)
          </p>

          <ol className="mt-3 pl-3">
            <li>
              All rooms must be contracted by Kiss & Tell and booked for a
              minimum of 3 nights to qualify.
            </li>
            <li>
              Cash gifts are paid by Kiss & Tell directly to the couple after
              completion of their group stay and Kiss & Tell's revenue is
              received from the venue.
            </li>
            <li>
              Offer is applicable to destination weddings or any group trip
              booking on Kiss & Tell (anniversaries, reunions, mitzvahs,
              bachelor / bachelorette trips, girls trips, guys trips, retreats,
              etc...) with a minimum of 20 adult guests staying for 3 nights.
            </li>
          </ol>
        </Modal.Body>
      </Modal>
      <span className={className} style={style} onClick={() => setShow(true)}>
        Terms & Conditions
      </span>
    </>
  )
}
